/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_Open_LeadInputs */

const cs_messages_open_lead = /** @type {(inputs: Messages_Open_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít lead`)
};

const en_messages_open_lead = /** @type {(inputs: Messages_Open_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open lead`)
};

/**
* | output |
* | --- |
* | "Open lead" |
*
* @param {Messages_Open_LeadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const messages_open_lead = /** @type {((inputs?: Messages_Open_LeadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_Open_LeadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_open_lead(inputs)
	return cs_messages_open_lead(inputs)
});